<template>
  <div id="app">
    <div class="animate__animated animate__fadeInDown bBottom" >
      <nav class="navbar fixed-top flex-md-nowrap p-0 shadow">
            <div class="companyTitle">
              <div class="logoBox">
                <svg width="4em" height="4em" viewBox="0 0 16 16" class="bi bi-check" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
                </svg>
              </div>
              <div class="titleContainer">
                <h1 class="headTitle">Система підрахунку голосів</h1>
                <h2 class="subTitle">Місцеві вибори, 2020</h2>
              </div>
            </div>
            <!--<ul class="navbar-nav px-3">-->
                <!--<li class="nav-item text-nowrap">-->
                <!--<button class="btn btn-sm btn-dark" v-show="roleModule==!0 || 2" @click="logOut">Вийти</button>-->
                <!--</li>-->
            <!--</ul>-->
      </nav>
      <!--<nav class="navbar navbar-light justify-content-between">-->
        <!--<div class="headContent">-->
          <!--<div class="logoBox">-->
            <!--<svg width="4em" height="4em" viewBox="0 0 16 16" class="bi bi-check" fill="#fff" xmlns="http://www.w3.org/2000/svg">-->
              <!--<path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>-->
            <!--</svg>-->
          <!--</div>-->
          <!--<div class="titleContainer">-->
            <!--<h1 class="headTitle">Система паралельного підрахунку голосів</h1>-->
            <!--<h2 class="subTitle">Місцеві вибори, 2020</h2>-->
          <!--</div>-->
        <!--</div>-->
        <!--<button class="btn btn-sm btn-dark" v-show="roleModule==!0 || 2" @click="logOut">Вийти</button>-->
      <!--</nav>-->

    </div>
    <!--<Login @logged="login" v-if="roleModule==0"/>-->
    <transition name="fade">
      <MainAdmin />
    </transition>
    <!--&lt;!&ndash;<transition name="fade">&ndash;&gt;-->
      <!--&lt;!&ndash;<dataEntry v-if="roleModule==2"/>&ndash;&gt;-->
    <!--&lt;!&ndash;</transition>&ndash;&gt;-->
    <!--<div v-if="roleModule ==3">-->
      <!--<h4> Це вхід тільки для адміністраторів </h4>-->
      <!--<p>Скористайтесь посиланням для подачі даних з ДВК <br>-->
        <!--<a :href="url">Вхід</a>-->
      <!--</p>-->
    <footer class="footer">
      <div class="container">
        <p style="text-align: right" class="text-muted">Програму відображення результатів створено: <a href="https://www.facebook.com/mykola.shchur">Микола Щур</a> і <a href="https://www.facebook.com/mykola.lupiy">Микола Лупій.</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
import MainAdmin from './components/MainAdmin.vue';
//import Login from './components/login.vue';
//import dataEntry from './components/dataEntry.vue';

export default {
    data() {
        return{ roleModule:1,
                role:''


        }
    },
    created(){
      //this.checkIsLogged();https://election-calc.online/
    },
  name: 'App',
  components: {
    MainAdmin,
    //  'Login': Login,
     // dataEntry
  },
    methods:{
        /*logOut() {
          sessionStorage.clear();
          localStorage.clear();
          this.roleModule = 0;
        },
        checkIsLogged() {
            let token = localStorage.getItem('token');
            this.$http.get(this.$URL_isLogged,{ params: {
                        'token': token
                    }}).then(responce=>{

                switch (responce.data.role) {
                    case 'admin':
                        this.roleModule = 1;
                        break;
                    case 'dataEntry':
                        this.roleModule = 2;
                        break;
                    case 'dvk':
                        this.roleModule = 0;
                        break;
                    case '':
                        this.roleModule = 0;
                        break;
                }
            }).catch(err=>console.log(err));
        },
    login(data) {
        console.log(data);
        this.role = data.role;
        switch (data.role) {
            case 'admin':
                this.roleModule = 1;
                break;
            case 'dataEntry':
                this.roleModule = 2;
                break;
                case 'dvk':
                this.roleModule = 3;
                break;
                case '':
                this.roleModule = 0;
                break;
        }
    }*/
    },
    computed: {
        url() {
            return this.$URL_dvk;
        }

    }
}
</script>

<style>
#app {
    font-family: 'Ubuntu', sans-serif;
    margin: 0;
    padding: 0;
}
.full-width {
        width: 98vw;
        position: relative;
        margin-left: -49vw;
        left: 50%;
}
.navbar{
  background: #fff;;
}
.companyTitle{
  margin: 0 20px;
}
.logoBox{
  background: #35adea;
  width: 2.9rem;
  height: 2.9rem;
  float: left;
  margin-top: 5px;
  margin-right: 10px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}
.titleContainer{
  display: table;
}
.headContent{
  align-items:center;
  text-align: left;
  margin: 5px 0;
}
.headTitle{
  font-size: 13px;
  display: inline-block;
  font-weight: 300;
  padding-top: 4px;
  /* line-height: .5; */
}
.subTitle{
  font-size: 18px;
}
.bBottom{
  border-bottom: solid 1px #ccc;
  align-items:center;
  margin-bottom: 20px;
  position: fixed;
  z-index: 99999999999;
  top: 0;
  left: 0;
  right: 0;
}
.btn {
  height: fit-content;
}
.form-control{
  font-weight: 300;
}
.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 70px 0 0 20px; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav li {
  font-weight: 300;
  color: #333;
  font-size: 14px;
  padding: 2px 0;
}
.sidebar .nav li:hover{
  color: #35adea;
  cursor: pointer;
}
.sidebar .nav li.active{
  color: #333;
  font-weight: bold;
}
.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}

.position-relative {
  position: relative;
}

.sticky-header {
  position: sticky !important;
  top: 57px !important;
  background: #969696;
  z-index: 100;
}
</style>
